import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-menu-icon',
    templateUrl: './menu-icon.component.html',
    styleUrls: ['./menu-icon.component.scss']
})
export class MenuIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 16;
        this.width = 22;
    }
}
